export const LIST_PREVIEW_ANNOUNCEMENTS = 'LIST_PREVIEW_ANNOUNCEMENTS';
export const LIST_ANNOUNCEMENTS = 'LIST_ANNOUNCEMENTS';
export const MODAL_CONTENT = 'MODAL_CONTENT';
